import request from "../servises/blogRequest";

export function getMediaList(params) {
    return request({
        url: `media`,
        method: 'GET',
        params: params
    })
}

export function getMedia(params) {
    return request({
        url: `media/${params}`,
        method: 'GET'
    })
}

export function updateMedia(params) {
    return request({
        url: `media/${params.id}`,
        method: 'PUT',
        data: {original_name: params.original_name}
    })
}

export function createMedia(params) {
    let formData = new FormData();

    formData.append('model_dir_name', params.model_dir_name);
    formData.append('file', params.file);

    return request({
        url: `media`,
        method: 'POST',
        data: formData
    })
}
export function deleteMedia(params) {
    return request({
        url: `media/${params}`,
        method: 'DELETE'
    })
}